import type { RefObject } from "react";
import { PureComponent } from "react";

import * as css from "./ErrorContainer.module.css";

export interface IErrorContainer {
    ref?: string;
    targetRefObj?: RefObject<HTMLDivElement>;
    dataTestId?: string;
}

export class ErrorContainer extends PureComponent<IErrorContainer> {
    public render() {
        return (
            <div
                className={css.errorContainerComponent}
                ref={this.props.targetRefObj}
                data-testid={this.props.dataTestId}
            />
        );
    }
}
